import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRiderDetails } from '../api/services/Riders';
import { RiderDetails } from '../types/rider';

interface IUseRideDetailsQuery {
  riderSlug: string;
}

const RIDER_DETAILS_QUERY_KEY = 'riderDetails';

export const useRiderDetailsQuery = ({ riderSlug }: IUseRideDetailsQuery) => {
  return useApiGet<{ data: RiderDetails }>([RIDER_DETAILS_QUERY_KEY, riderSlug], () => getRiderDetails(riderSlug), {
    enabled: !!riderSlug,
  });
};
